var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-how_it_works"}},[(_vm.loading)?_c('Loading'):_c('HowItWorks',{attrs:{"customItems":_vm.customItemsHowItWorks,"text":_vm.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }